import HelpContact from 'components/ModalFaqs/Sections/FaqsWithMarkup/HelpContact/styled';

export default HelpContact;
